document.addEventListener('DOMContentLoaded', function () {

  /* ── NAV SCROLL SHADOW ── */
  const nav = document.getElementById('gcNav');
  if (nav) window.addEventListener('scroll', function () { nav.classList.toggle('scrolled', window.scrollY > 40); });

  /* ── MOBILE NAV ── */
  window.toggleMobileNav = function () {
    const mn = document.getElementById('mobileNav');
    if (mn) mn.classList.toggle('open');
  };

  /* ── TOAST ── */
  window.showToast = function (msg) {
    const t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg; t.classList.add('show');
    setTimeout(function () { t.classList.remove('show'); }, 2800);
  };

  /* ── CART COUNT ── */
  window.updateCartCount = function () {
    fetch('/cart.js').then(r => r.json()).then(function (cart) {
      const b = document.getElementById('cartCount');
      if (b) b.textContent = cart.item_count;
    });
  };
  updateCartCount();

  /* ── ADD TO CART (AJAX) ── */
  window.addToCartAjax = function (variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(r => r.json()).then(function (data) {
      showToast('Added — ' + data.title);
      updateCartCount();
    }).catch(function () { showToast('Could not add to cart'); });
  };

  /* ── CALENDLY MODAL ── */
  window.openCalendly = function () {
    const overlay = document.getElementById('calendlyOverlay');
    const frame   = document.getElementById('calendlyFrame');
    if (!overlay) return;
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    const url = overlay.dataset.calendlyUrl;
    if (url && url.length > 0 && frame && !frame.querySelector('iframe')) {
      const iframe = document.createElement('iframe');
      iframe.src = url; iframe.width = '100%'; iframe.height = '100%'; iframe.frameBorder = '0';
      frame.innerHTML = ''; frame.appendChild(iframe);
    }
  };
  window.closeCalendly = function () {
    const o = document.getElementById('calendlyOverlay');
    if (o) o.classList.remove('open');
    document.body.style.overflow = '';
  };
  const co = document.getElementById('calendlyOverlay');
  if (co) co.addEventListener('click', function (e) { if (e.target === co) window.closeCalendly(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') window.closeCalendly(); });

  /* ── SHOP FILTER ── */
  window.shopFilter = function (btn, cat) {
    document.querySelectorAll('.shop-filter').forEach(b => b.classList.remove('on'));
    btn.classList.add('on');
    document.querySelectorAll('#shopGrid [data-cat]').forEach(function (card) {
      card.style.display = (cat === 'all' || card.dataset.cat === cat) ? '' : 'none';
    });
    const f = document.querySelector('.product-featured');
    if (f) f.style.display = (cat === 'all' || cat === 'tools') ? '' : 'none';
  };

  /* ── COPY CODE ── */
  window.copyCode = function (code) {
    navigator.clipboard.writeText(code).then(function () { showToast('Code copied — ' + code); })
      .catch(function () { showToast('Code: ' + code); });
  };

  /* ── SCROLL TO ANCHOR ── */
  window.scrollToId = function (id) {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

});
